import React from 'react';
import { Link } from 'react-router-dom';

const ErrorPage = () => {
    return (
        <>
            <section id="error_page" className="section">
                <div className="container">
                    <div className="error_page_content">
                        <h1>404</h1>
                        <h2>Nie znaleziono</h2>
                        <h3>Przepraszamy, żądana strona nie została znaleziona.</h3>
                        <Link to="/" className="btn">Wróć na stronę główną</Link>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ErrorPage;
